import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ToastType = 'error' | 'info'

interface ToastState {
	show: boolean
	message: string
	type: ToastType
}

const initialState: ToastState = {
	show: false,
	message: '',
	type: 'error',
}

interface ShowToastPayload {
	message: string
	type?: ToastType
}

const toastSlice = createSlice({
	name: 'toast',
	initialState,
	reducers: {
		showToast: (state, action: PayloadAction<ShowToastPayload | string>) => {
			if (typeof action.payload === 'string') {
				state.message = action.payload
				state.type = 'error'
			} else {
				state.message = action.payload.message
				state.type = action.payload.type || 'error'
			}
			state.show = true
		},
		hideToast: (state) => {
			state.show = false
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			(action) =>
				action.type.endsWith('/uploadInvoiceFile/fulfilled'),
			(state) => {
				state.message = 'Файл успішно завантажено'
				state.type = 'info'
				state.show = true
			}
		)
	},
})

export const { showToast, hideToast } = toastSlice.actions
export default toastSlice.reducer

